import HighlightLogoIcon from '@renderer/components/Icons/HighlightLogoIcon'
import WorkOsIpcRenderer from '@renderer/ipc/WorkOsIpc.renderer'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import { Modal } from '../index'
import { Button } from '@highlight/ui'

export const LoginRequiredModal = () => {
  const onCreateAccount = () => {
    AmplitudeRenderer.trackEvent('Auth', {
      action: 'Sign Up',
      source: 'Base app login modal',
      authenticationStep: 'Open login page',
    })
    WorkOsIpcRenderer.showSignIn('sign-up')
  }

  const onSignIn = () => {
    AmplitudeRenderer.trackEvent('Auth', {
      action: 'Sign In',
      source: 'Base app login modal',
      authenticationStep: 'Open login page',
    })
    WorkOsIpcRenderer.showSignIn('sign-in')
  }

  return (
    <Modal confirm disableEscape>
      <Modal.Content showClose={false}>
        <div className="flex flex-col items-center gap-2 p-8">
          <HighlightLogoIcon size={40} className="text-foreground" />
          <Modal.Title className="type-h2 font-semibold">Welcome to Highlight</Modal.Title>
          <div className="mt-4 flex max-w-[350px] flex-col items-center gap-3 text-center">
            <Button variant="primary" className="w-[230px]" onClick={onCreateAccount}>
              Create your account
            </Button>
            <Button variant="outline" className="w-[230px]" onClick={onSignIn}>
              Sign in
            </Button>
            <div className="text-foreground-secondary [&_a]:text-foreground text-xs font-medium">
              By creating your account, you agree to our{' '}
              <a
                href="https://highlightai.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground cursor-pointer underline"
              >
                Terms of Service
              </a>{' '}
              and{' '}
              <a
                href="https://highlightai.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground cursor-pointer underline"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  )
}
